import React from 'react';

// Íconos de línea al estilo de las ilustraciones de frè (trazo redondeado, sin emojis)
const base = (size) => ({
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
});

export const Destello = ({ size = 24, className }) => (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 1.5c.6 5.2 2.8 8.4 10.5 10.5-7.7 2.1-9.9 5.3-10.5 10.5C11.4 17.3 9.2 14.1 1.5 12 9.2 9.9 11.4 6.7 12 1.5Z" fill="currentColor" />
    </svg>
);

export const Rafaga = ({ size = 28, className, flip = false }) => (
    <svg className={className} width={size} height={size} viewBox="0 0 28 28" aria-hidden="true"
        style={flip ? { transform: 'scaleX(-1)' } : undefined}>
        <g stroke="currentColor" strokeWidth="2.6" strokeLinecap="round">
            <path d="M6 10 11 13" />
            <path d="M9 3.5 13 9.5" />
            <path d="M17 2.5 17.5 9" />
        </g>
    </svg>
);

export const Estrella = ({ size = 18, className, style }) => (
    <svg className={className} style={style} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 2.8l2.7 5.6 6.1.8-4.5 4.2 1.1 6.1L12 16.6l-5.4 2.9 1.1-6.1-4.5-4.2 6.1-.8L12 2.8Z" fill="currentColor" />
    </svg>
);

export const Regalo = ({ size = 24, className, style }) => (
    <svg className={className} style={style} {...base(size)}>
        <rect x="3.5" y="8.5" width="17" height="4" rx="1" />
        <path d="M5 12.5v7a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5v-7" />
        <path d="M12 8.5V21" />
        <path d="M12 8.5S10.6 4 8 4a2.2 2.2 0 0 0 0 4.5h4Z" />
        <path d="M12 8.5S13.4 4 16 4a2.2 2.2 0 0 1 0 4.5h-4Z" />
    </svg>
);

export const Bolsa = ({ size = 24, className }) => (
    <svg className={className} {...base(size)}>
        <path d="M5 8h14l-1.2 11.2a2 2 0 0 1-2 1.8H8.2a2 2 0 0 1-2-1.8L5 8Z" />
        <path d="M9 10V7a3 3 0 0 1 6 0v3" />
    </svg>
);

export const Corazon = ({ size = 20, className }) => (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 20.5S3 15 3 8.9A4.6 4.6 0 0 1 12 7a4.6 4.6 0 0 1 9 1.9C21 15 12 20.5 12 20.5Z" fill="currentColor" />
    </svg>
);

export const Vaso = ({ size = 24, className, style }) => (
    <svg className={className} style={style} {...base(size)}>
        <path d="M5.5 9.5h13l-1.6 10.3a1.5 1.5 0 0 1-1.5 1.2H8.6a1.5 1.5 0 0 1-1.5-1.2L5.5 9.5Z" />
        <path d="M5 9.5c0-2.2 2-3.2 3.6-3 .4-1.8 2-3 3.4-3s3 1.2 3.4 3c1.6-.2 3.6.8 3.6 3" />
        <path d="M7 14c2 .9 3.3-.9 5 0s3 .9 5 0" />
    </svg>
);

export const Buscar = ({ size = 22, className }) => (
    <svg className={className} {...base(size)}>
        <circle cx="11" cy="11" r="6.5" />
        <path d="m20 20-4.2-4.2" />
    </svg>
);

export const Flecha = ({ size = 20, className }) => (
    <svg className={className} {...base(size)}>
        <path d="M5 12h14" />
        <path d="m13 6 6 6-6 6" />
    </svg>
);

export const Mas = ({ size = 18, className }) => (
    <svg className={className} {...base(size)}><path d="M12 5v14M5 12h14" /></svg>
);

export const Menos = ({ size = 18, className }) => (
    <svg className={className} {...base(size)}><path d="M5 12h14" /></svg>
);

